import useHttpPost from "./useHttpPost";

export default function usePostVehicleModel(target){
    return useHttpPost("vehiclemodel", "post", {}, target);
}